import { render, staticRenderFns } from "./ModuleChip.vue?vue&type=template&id=57e75767"
import script from "./ModuleChip.vue?vue&type=script&lang=js"
export * from "./ModuleChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports